import { getTranslateFn } from '@project44/translations-utils';

import { translations } from '../../l10n/config';
import { UI_TRANSLATIONS_NAMESPACE } from '../constants';

export const i18nTranslationsHandler = () =>
  getTranslateFn(UI_TRANSLATIONS_NAMESPACE, translations);
